import { useCallback, useMemo } from "react";
import { useApi } from "./api";

// Admin-only user management, backed by /api/users (backend/users.py), which
// acts through Logto's Management API. The backend refuses every call from a
// non-admin, and answers errors with { message } written for the admin to read.
export const useUsersApi = () => {
  const { apiFetch } = useApi();

  const call = useCallback(
    async (path, options) => {
      const response = await apiFetch("/api/users" + path, options);
      const body = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(
          body?.message ?? `The server returned ${response.status}.`
        );
      }
      return body;
    },
    [apiFetch]
  );

  return useMemo(
    () => ({
      list: () => call(""),
      // Leave password out to have one generated; it comes back once, as
      // generatedPassword.
      add: ({ email, name, role, password }) =>
        call("", {
          method: "POST",
          body: JSON.stringify({ email, name, role, password }),
        }),
      resetPassword: (id, password) =>
        call(`/${encodeURIComponent(id)}/password`, {
          method: "POST",
          body: JSON.stringify({ password }),
        }),
      remove: (id) => call(`/${encodeURIComponent(id)}`, { method: "DELETE" }),
    }),
    [call]
  );
};
